
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ParseAdvPacketPayload, ParsedAdvPacket } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<unknown, Error, ParseAdvPacketPayload, ParsedAdvPacket>, 'mutationKey' | 'mutationFn'>
}

export const useParseAdvertisementPacketRequest = ({
  options = {},
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, ParseAdvPacketPayload, ParsedAdvPacket>(
    [Entities.AdvertisementPacket, 'parse'],
    async (payload: ParseAdvPacketPayload) => {
      const { data } = await api.v1AdminDiagnosticsParseAdvPacketPost(payload)
      return data
    },
    { ...options },
  )
}
